export default {"src":"/_next/static/media/reserve-logo-white.2df5747d.svg","height":111,"width":358,"blurWidth":0,"blurHeight":0};